// src/components/DevTools/styles.ts

export const devToolsStyles = (darkMode: boolean) => `
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.devtools-container {
  position: fixed;
  inset: 0;
  z-index: 999999;
  background: ${darkMode ? 'rgba(0, 0, 0, 0.95)' : 'rgba(0, 0, 0, 0.85)'};
  backdrop-filter: blur(8px);
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  color: ${darkMode ? '#ffffff' : '#000000'};
  display: flex;
  flex-direction: column;
}

.devtools-header {
  padding: 12px 20px;
  border-bottom: 1px solid ${darkMode ? '#334155' : '#e2e8f0'};
  background: ${darkMode ? '#1e293b' : '#f8fafc'};
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-shrink: 0;
}

.header-title {
  font-size: 16px;
  font-weight: 600;
  color: ${darkMode ? '#ffffff' : '#0f172a'};
}

.header-controls {
  display: flex;
  align-items: center;
  gap: 8px;
}

.control-btn {
  padding: 6px;
  background: ${darkMode ? '#334155' : '#ffffff'};
  border: 1px solid ${darkMode ? '#475569' : '#cbd5e1'};
  border-radius: 6px;
  cursor: pointer;
  color: ${darkMode ? '#ffffff' : '#334155'};
  display: flex;
  align-items: center;
  justify-content: center;
}

.control-btn:hover {
  background: ${darkMode ? '#475569' : '#f1f5f9'};
}

.control-btn.active {
  background: #3b82f6;
  color: white;
  border-color: #3b82f6;
}

.control-group {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 4px;
  background: ${darkMode ? '#334155' : '#f1f5f9'};
  border-radius: 6px;
}

.more-controls {
  position: relative;
}

.more-dropdown {
  position: absolute;
  top: 100%;
  right: 0;
  margin-top: 4px;
  background: ${darkMode ? '#1e293b' : '#ffffff'};
  border: 1px solid ${darkMode ? '#334155' : '#e2e8f0'};
  border-radius: 8px;
  padding: 8px;
  box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  min-width: 180px;
}

.more-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px;
  cursor: pointer;
  border-radius: 4px;
  font-size: 13px;
  color: ${darkMode ? '#cbd5e1' : '#475569'};
}

.more-item:hover {
  background: ${darkMode ? '#334155' : '#f1f5f9'};
}

.more-item.active {
  background: ${darkMode ? '#1e40af' : '#eff6ff'};
  color: ${darkMode ? '#ffffff' : '#1e40af'};
  font-weight: 500;
}

.content-wrapper {
  display: flex;
  flex: 1;
  overflow: hidden;
}

.sidebar {
  width: 300px;
  background: ${darkMode ? '#1e293b' : '#f8fafc'};
  border-right: 1px solid ${darkMode ? '#334155' : '#e2e8f0'};
  overflow-y: auto;
  padding: 16px;
  flex-shrink: 0;
}

.preset-btn {
  padding: 8px 12px;
  background: ${darkMode ? '#334155' : '#ffffff'};
  border: 1px solid ${darkMode ? '#475569' : '#cbd5e1'};
  border-radius: 6px;
  cursor: pointer;
  font-size: 11px;
  font-weight: 500;
  text-align: center;
  color: ${darkMode ? '#ffffff' : '#334155'};
}

.preset-btn:hover {
  background: ${darkMode ? '#475569' : '#f1f5f9'};
}

.device-category {
  margin-bottom: 16px;
}

.category-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}

.category-title {
  font-weight: 500;
  font-size: 12px;
  color: ${darkMode ? '#cbd5e1' : '#475569'};
  display: flex;
  align-items: center;
  gap: 6px;
}

.category-count {
  font-size: 10px;
  padding: 2px 6px;
  background: ${darkMode ? '#475569' : '#e2e8f0'};
  border-radius: 10px;
  color: ${darkMode ? '#cbd5e1' : '#475569'};
}

.device-list {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.device-item {
  padding: 12px;
  border: 1px solid ${darkMode ? '#475569' : '#cbd5e1'};
  border-radius: 8px;
  background: ${darkMode ? '#334155' : '#ffffff'};
  cursor: pointer;
}

.device-item:hover {
  background: ${darkMode ? '#475569' : '#f8fafc'};
}

.device-item.selected {
  background: ${darkMode ? '#1e40af' : '#eff6ff'};
  border-color: #3b82f6;
}

.device-name {
  font-weight: 500;
  font-size: 13px;
  color: ${darkMode ? '#ffffff' : '#0f172a'};
  margin-bottom: 6px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.device-specs {
  font-size: 11px;
  color: ${darkMode ? '#94a3b8' : '#64748b'};
  display: flex;
  gap: 8px;
  align-items: center;
  flex-wrap: wrap;
}

.preview-area {
  flex: 1;
  overflow: auto;
  background: ${darkMode ? '#0f172a' : '#f1f5f9'};
  position: relative;
}

.preview-content {
  padding: 16px;
  height: 100%;
}

.preview-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  align-items: flex-start;
  justify-content: center;
}

.device-preview {
  background: ${darkMode ? '#1e293b' : '#ffffff'};
  border-radius: 16px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  overflow: hidden;
  border: 1px solid ${darkMode ? '#334155' : '#e2e8f0'};
  flex-shrink: 0;
  position: relative;
}

.device-header {
  padding: 10px 14px;
  background: ${darkMode ? '#334155' : '#f8fafc'};
  border-bottom: 1px solid ${darkMode ? '#475569' : '#e2e8f0'};
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.device-title {
  font-weight: 500;
  font-size: 12px;
  color: ${darkMode ? '#ffffff' : '#0f172a'};
  display: flex;
  align-items: center;
  gap: 6px;
}

.device-info {
  font-size: 10px;
  color: ${darkMode ? '#94a3b8' : '#64748b'};
  display: flex;
  gap: 6px;
  align-items: center;
}

.device-actions {
  display: flex;
  gap: 2px;
}

.action-btn {
  padding: 4px;
  background: transparent;
  border: none;
  cursor: pointer;
  color: ${darkMode ? '#94a3b8' : '#64748b'};
  border-radius: 4px;
}

.action-btn:hover {
  background: ${darkMode ? '#475569' : '#e2e8f0'};
  color: ${darkMode ? '#ffffff' : '#0f172a'};
}

.action-btn.active {
  background: #3b82f6;
  color: white;
}

.remove-btn:hover {
  background: ${darkMode ? '#450a0a' : '#fecaca'};
  color: ${darkMode ? '#fca5a5' : '#dc2626'};
}

.test-btn {
  padding: 4px 6px;
  background: ${darkMode ? '#475569' : '#e2e8f0'};
  color: ${darkMode ? '#ffffff' : '#334155'};
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 10px;
  font-weight: 500;
}

.test-btn:hover {
  background: ${darkMode ? '#1e40af' : '#3b82f6'};
  color: white;
}

.test-btn:disabled {
  background: #6b7280;
  cursor: not-allowed;
  color: #9ca3af;
}

.device-body {
  position: relative;
}

.device-chrome {
  position: relative;
  background: ${darkMode ? '#1e293b' : '#ffffff'};
}

.ios-notch {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 160px;
  height: 32px;
  background: linear-gradient(135deg, #000000, #1a1a1a);
  border-radius: 0 0 16px 16px;
  z-index: 20;
  box-shadow: inset 0 -2px 4px rgba(255,255,255,0.1);
}

.ios-status-bar {
  height: 44px;
  background: ${darkMode ? '#000000' : '#ffffff'};
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  font-size: 15px;
  font-weight: 600;
  color: ${darkMode ? '#ffffff' : '#000000'};
  position: relative;
  z-index: 15;
}

.ios-status-left {
  display: flex;
  align-items: center;
  gap: 4px;
}

.ios-status-right {
  display: flex;
  align-items: center;
  gap: 4px;
}

.android-status-bar {
  height: 24px;
  background: ${darkMode ? '#212121' : '#ffffff'};
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;
  font-size: 12px;
  font-weight: 500;
  color: ${darkMode ? '#ffffff' : '#000000'};
}

.android-status-left {
  display: flex;
  align-items: center;
  gap: 6px;
}

.android-status-right {
  display: flex;
  align-items: center;
  gap: 4px;
}

.macos-chrome, .windows-chrome {
  height: 72px;
  background: ${darkMode ? '#1c1c1e' : '#f6f6f6'};
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid ${darkMode ? '#38383a' : '#d1d1d6'};
}

.titlebar {
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 12px;
  background: ${darkMode ? '#323233' : '#ebebeb'};
  border-bottom: 1px solid ${darkMode ? '#38383a' : '#d1d1d6'};
}

.browser-controls {
  display: flex;
  gap: 8px;
  align-items: center;
}

.browser-btn {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  border: none;
  cursor: pointer;
  position: relative;
}

.browser-btn::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  opacity: 0;
  transition: opacity 0.2s;
}

.browser-btn:hover::after {
  opacity: 1;
}

.btn-close { background: #ff5f57; }
.btn-close:hover::after {
  content: '×';
  color: #8b0000;
  font-size: 10px;
  font-weight: bold;
}

.btn-minimize { background: #ffbd2e; }
.btn-minimize:hover::after {
  content: '−';
  color: #996600;
  font-size: 10px;
  font-weight: bold;
}

.btn-maximize { background: #28ca42; }
.btn-maximize:hover::after {
  content: '+';
  color: #006600;
  font-size: 10px;
  font-weight: bold;
}

.window-title {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  font-size: 13px;
  font-weight: 500;
  color: ${darkMode ? '#ffffff' : '#333333'};
}

.toolbar {
  flex: 1;
  display: flex;
  align-items: center;
  padding: 6px 12px;
  gap: 8px;
}

.nav-buttons {
  display: flex;
  gap: 4px;
}

.nav-btn {
  width: 24px;
  height: 24px;
  border: 1px solid ${darkMode ? '#48484a' : '#d1d1d6'};
  background: ${darkMode ? '#48484a' : '#ffffff'};
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: ${darkMode ? '#ffffff' : '#333333'};
}

.nav-btn:hover {
  background: ${darkMode ? '#5a5a5c' : '#f0f0f0'};
}

.nav-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.address-bar {
  flex: 1;
  height: 28px;
  background: ${darkMode ? '#48484a' : '#ffffff'};
  border: 1px solid ${darkMode ? '#38383a' : '#d1d1d6'};
  border-radius: 6px;
  padding: 0 8px;
  font-size: 13px;
  color: ${darkMode ? '#ffffff' : '#000000'};
  display: flex;
  align-items: center;
  gap: 6px;
  margin: 0 8px;
}

.device-viewport {
  position: relative;
  overflow: hidden;
  background: white;
}

.device-iframe {
  border: none;
  transform-origin: top left;
  background: white;
}

.device-loading {
  position: absolute;
  inset: 0;
  background: ${darkMode ? '#1e293b' : '#f8fafc'};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 8px;
  z-index: 10;
  font-size: 11px;
  color: ${darkMode ? '#94a3b8' : '#64748b'};
}

.spinner {
  width: 20px;
  height: 20px;
  border: 2px solid ${darkMode ? '#475569' : '#e2e8f0'};
  border-top: 2px solid #3b82f6;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

.accessibility-filter {
  position: absolute;
  inset: 0;
  pointer-events: none;
  z-index: 5;
}

.contrast-filter {
  background: repeating-linear-gradient(
    45deg,
    transparent,
    transparent 10px,
    rgba(255,255,255,0.05) 10px,
    rgba(255,255,255,0.05) 20px
  );
}

.colorblind-filter {
  filter: sepia(1) saturate(0) hue-rotate(180deg);
}

.grid-overlay {
  position: absolute;
  inset: 0;
  pointer-events: none;
  background-image: 
    linear-gradient(to right, rgba(59, 130, 246, 0.1) 1px, transparent 1px),
    linear-gradient(to bottom, rgba(59, 130, 246, 0.1) 1px, transparent 1px);
  background-size: 20px 20px;
  z-index: 5;
}

.floating-metrics {
  position: fixed;
  bottom: 20px;
  right: 20px;
  width: 700px;
  max-width: calc(100vw - 40px);
  max-height: 80vh;
  background: ${darkMode ? 'rgba(15, 23, 42, 0.98)' : 'rgba(255, 255, 255, 0.98)'};
  backdrop-filter: blur(16px);
  border: 1px solid ${darkMode ? '#334155' : '#e2e8f0'};
  border-radius: 16px;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  z-index: 1000000;
  overflow: hidden;
}

.metrics-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px;
  border-bottom: 1px solid ${darkMode ? '#334155' : '#e2e8f0'};
  background: ${darkMode ? '#1e293b' : '#f8fafc'};
}

.metrics-title {
  font-weight: 600;
  font-size: 14px;
  color: ${darkMode ? '#ffffff' : '#0f172a'};
}

.metrics-controls {
  display: flex;
  align-items: center;
  gap: 4px;
}

.tab-navigation {
  display: flex;
  gap: 2px;
  margin-bottom: 20px;
}

.tab-btn {
  padding: 8px 16px;
  background: ${darkMode ? '#334155' : '#f1f5f9'};
  color: ${darkMode ? '#cbd5e1' : '#64748b'};
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 500;
}

.tab-btn.active {
  background: #3b82f6;
  color: white;
}

.tab-btn:hover:not(.active) {
  background: ${darkMode ? '#475569' : '#e2e8f0'};
}

.metrics-content {
  padding: 24px;
  overflow-y: auto;
  max-height: calc(80vh - 68px);
}

.lighthouse-scores {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 16px;
  margin-bottom: 24px;
}

.score-item {
  text-align: center;
  padding: 16px 12px;
  border-radius: 12px;
  background: ${darkMode ? '#334155' : '#f8fafc'};
  border: 1px solid ${darkMode ? '#475569' : '#e2e8f0'};
  position: relative;
}

.score-value {
  font-size: 28px;
  font-weight: 700;
  margin-bottom: 6px;
  line-height: 1;
}

.score-label {
  font-size: 12px;
  opacity: 0.7;
  font-weight: 500;
}

.score-status {
  position: absolute;
  top: 8px;
  right: 8px;
  font-size: 10px;
  padding: 2px 6px;
  border-radius: 4px;
  font-weight: 600;
}

.vitals-section {
  margin-bottom: 24px;
}

.section-title {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 16px;
  color: ${darkMode ? '#ffffff' : '#0f172a'};
  padding-bottom: 8px;
  border-bottom: 1px solid ${darkMode ? '#334155' : '#e2e8f0'};
  display: flex;
  align-items: center;
  gap: 8px;
}

.vitals-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
}

.vital-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  background: ${darkMode ? '#334155' : '#f8fafc'};
  border-radius: 12px;
  border: 1px solid ${darkMode ? '#475569' : '#e2e8f0'};
}

.vital-content {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.vital-label {
  font-size: 12px;
  font-weight: 500;
  color: ${darkMode ? '#cbd5e1' : '#64748b'};
}

.vital-value {
  font-size: 18px;
  font-weight: 700;
  color: ${darkMode ? '#ffffff' : '#0f172a'};
}

.vital-benchmark {
  font-size: 10px;
  opacity: 0.6;
  color: ${darkMode ? '#94a3b8' : '#6b7280'};
}

.vital-status {
  display: flex;
  align-items: center;
  justify-content: center;
}

.performance-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  margin-bottom: 24px;
}

.performance-item {
  padding: 16px;
  background: ${darkMode ? '#334155' : '#f8fafc'};
  border-radius: 12px;
  border: 1px solid ${darkMode ? '#475569' : '#e2e8f0'};
}

.performance-label {
  font-size: 12px;
  font-weight: 500;
  color: ${darkMode ? '#cbd5e1' : '#64748b'};
  margin-bottom: 8px;
}

.performance-value {
  font-size: 16px;
  font-weight: 600;
  color: ${darkMode ? '#ffffff' : '#0f172a'};
}

.accessibility-section, .seo-section, .security-section {
  margin-bottom: 20px;
}

.accessibility-issue {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 16px;
  margin-bottom: 12px;
  background: ${darkMode ? '#334155' : '#f8fafc'};
  border-radius: 12px;
  border: 1px solid ${darkMode ? '#475569' : '#e2e8f0'};
}

.issue-severity {
  padding: 4px 8px;
  border-radius: 6px;
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.025em;
  flex-shrink: 0;
}

.severity-critical { background: #fecaca; color: #dc2626; }
.severity-serious { background: #fed7aa; color: #ea580c; }
.severity-moderate { background: #fef3c7; color: #d97706; }
.severity-minor { background: #dcfce7; color: #16a34a; }

.issue-content {
  flex: 1;
}

.issue-message {
  font-size: 13px;
  font-weight: 500;
  color: ${darkMode ? '#ffffff' : '#0f172a'};
  margin-bottom: 4px;
}

.issue-details {
  font-size: 11px;
  color: ${darkMode ? '#94a3b8' : '#64748b'};
  display: flex;
  gap: 12px;
  align-items: center;
}

.seo-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
  margin-bottom: 20px;
}

.seo-category {
  background: ${darkMode ? '#334155' : '#f8fafc'};
  border-radius: 12px;
  border: 1px solid ${darkMode ? '#475569' : '#e2e8f0'};
  padding: 16px;
}

.seo-category-title {
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 12px;
  color: ${darkMode ? '#ffffff' : '#0f172a'};
  display: flex;
  align-items: center;
  gap: 8px;
}

.seo-checklist {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.seo-item {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 13px;
  padding: 8px 0;
}

.seo-check { color: #10b981; font-weight: 600; }
.seo-fail { color: #ef4444; font-weight: 600; }

.recommendations {
  margin-top: 16px;
}

.recommendation-item {
  padding: 8px 12px;
  background: ${darkMode ? '#1e293b' : '#eff6ff'};
  border-radius: 6px;
  margin-bottom: 6px;
  font-size: 12px;
  color: ${darkMode ? '#cbd5e1' : '#1e40af'};
  border-left: 3px solid #3b82f6;
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: ${darkMode ? '#94a3b8' : '#64748b'};
  text-align: center;
}

.fullscreen-overlay {
  position: fixed;
  inset: 0;
  z-index: 1000001;
  background: ${darkMode ? '#000000' : '#ffffff'};
  display: flex;
  flex-direction: column;
}

.fullscreen-header {
  padding: 12px 20px;
  background: ${darkMode ? '#1e293b' : '#f8fafc'};
  border-bottom: 1px solid ${darkMode ? '#334155' : '#e2e8f0'};
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.fullscreen-viewport {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
`
